import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Environment } from 'src/app/classes/environment';


@Component({
	selector: 'export-csv',
	templateUrl: './export-csv.component.html',
})
export class ExportCSVComponent {


	bDownloading = false;
	subscriptions = new Subscription();


	constructor(
		private _http: HttpClient,
		@Inject('environment') private environment: Environment,
	) {}



	download() {

		this.bDownloading = true;

		this._http.get(
			this.environment.backendUrl + 'export/csv',
			{ responseType: 'blob' }
		).subscribe( data => {

			this.bDownloading = false;

			const blob = new Blob( [data], { type: "application/zip" });
			const file = new File(
				[blob],
				"export.zip",
				{ type: "application/zip", lastModified: Date.now() }
			);
			const fileURL = URL.createObjectURL(file);

			window.open( fileURL, '_blank' );

		});

	}

}
